import React from 'react';
import { t } from 'Src/i18n';
import { ICONS } from 'Components/utils/icon/icons';
import { TransferBulletPoints } from './TransferBulletPoints';
import { TransferInDetails } from './TransferInDetails';
type TransfersInfosProps = {
  hasSelectedTransfer: boolean;
  resort: Product;
  selectedProposal: Proposal;
};
export const TransfersInfos = ({
  hasSelectedTransfer,
  resort,
  selectedProposal,
}: TransfersInfosProps) => {
  const hasParking = resort?.facilities?.some(
    (facility) => facility.type && facility.type === 'PARKING',
  );
  const firstTransfer = selectedProposal.additionalServices.transfers?.[0];
  const { startDate: firstTransferStartDate, endDate: firstTransferEndDate } =
    firstTransfer?.pricingInfo.schedules[0] || {};
  const isOneWayTransfer = firstTransfer?.pricingInfo.schedules.length === 1;
  const transferBulletPointTitle = 'common.transport.transfer.title';
  let transferBulletPoints = [
    'common.transport.transfer.arrivalPoint',
    'common.transport.transfer.roundTrip',
  ];

  if (isOneWayTransfer) {
    const isOutBoundTransfer = firstTransferStartDate === selectedProposal.departureDate;
    const isInBoundTransfer = firstTransferEndDate === selectedProposal.arrivalDate;

    if (isOutBoundTransfer) {
      transferBulletPoints = ['common.transport.transfer.outboundOnlyIncluded'];
    }

    if (isInBoundTransfer) {
      transferBulletPoints = [
        'common.transport.transfer.arrivalPoint',
        'common.transport.transfer.inboundOnlyIncluded',
      ];
    }
  }

  return (
    <div className="mt-40">
      <TransferBulletPoints title={transferBulletPointTitle} bulletPoints={transferBulletPoints} />
      <div className="mt-40 items-start justify-between md:flex">
        {hasSelectedTransfer && (
          <div className="mb-20 md:mb-0 md:w-2/5">
            <TransferInDetails
              iconName={ICONS.LIGHTBULB}
              description={t('common.transport.transfer.reassuranceTransportDescription')}
              detail={t('common.transport.transfer.reassuranceTransportDetails')}
            />
          </div>
        )}
        {hasParking && (
          <div className="md:w-2/5">
            <TransferInDetails
              iconName={ICONS.CAR_PARK}
              description={t('booking.transport.transfer.parking.insterDescription')}
              detail={t('booking.transport.transfer.parking.insterDetails')}
            />
          </div>
        )}
      </div>
    </div>
  );
};
